export const EVENT_REGION_MAPPING = {
  eventTakesPlacesInAfrica: 'willingToTravelToAfrica',
  eventTakesPlacesInAsia: 'willingToTravelToAsia',
  eventTakesPlacesInAustralia: 'willingToTravelToAustralia',
  eventTakesPlacesInEurope: 'willingToTravelToEurope',
  eventTakesPlacesInNorthAmerica: 'willingToTravelToNorthAmerica',
  eventTakesPlacesInSouthAmerica: 'willingToTravelToSouthAmerica',
  eventTakesPlacesInVirtual: 'willingToTravelToVirtual'
};
